import { X_DEVICE_ID } from '../constants';
import { UserListResponse } from './commonResponse';
import { deleteReq, get, patch, post } from './request';

export type ChatGroupRoomUserResponse = UserListResponse & {
    is_muted: boolean;
};

export type V1ChatGroupRoomDetailResponse = {
    id: number;
    name: string;
    token: string;
    chat_group_id: number;
    chat_group_name: string;
    users: ChatGroupRoomUserResponse[];
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ChatGroupRoomUserApi = (groupId: number, roomId: number) => {
    const baseUrl =
        process.env.REACT_APP_COCALERO_API_URL +
        `/v1/chat_groups/${groupId}/chat_group_rooms/${roomId}/chat_group_room_users`;

    return {
        index: (): Promise<V1ChatGroupRoomDetailResponse> =>
            get(baseUrl).then((res: { chat_group_room: V1ChatGroupRoomDetailResponse }) => res.chat_group_room),

        create: (): Promise<V1ChatGroupRoomDetailResponse> =>
            post(baseUrl, {}, { 'X-Device-Id': X_DEVICE_ID }).then(
                (res: { chat_group_room: V1ChatGroupRoomDetailResponse }) => res.chat_group_room
            ),

        update: (isMute: boolean): Promise<void> =>
            patch(baseUrl, {
                chat_group_room_user: {
                    is_muted: isMute,
                },
            }),

        leave: (): Promise<void> => deleteReq(baseUrl, {}),
    };
};
